export default __webpack_public_path__ + "static/media/user_subscription_waiting.97a83a58.svg";